import React, { Component } from "react";
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';


import { NavLink,Outlet } from 'react-router-dom';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';


import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';

import innerAthalogo from './images/logo.jpg';
import notification from './images/notification.jpg';
import person from './images/person.jpg';
import Menu from '@mui/material/Menu';
import smalllogo from './images/small-logo.png';
import Slidenotification from './Slidenotification';
import MenuItem from '@mui/material/MenuItem';
import SubdirectoryArrowRightIcon from '@mui/icons-material/ArrowRightAlt';


import TableViewIcon from '@mui/icons-material/TableView';
import SummarizeIcon from '@mui/icons-material/Summarize';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import Badge from '@mui/material/Badge';

import NotificationsNoneIcon from '@mui/icons-material/NotificationsNoneOutlined';
const drawerWidth = 250;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));


export default class PersistentDrawerLeft extends Component {

    constructor(props) {
    super(props);
    this.state = {open: false,open1:false ,invisible:true,menu1:false,menu3:false,anchorEl:false,menuopen:false,menu2:false,ldcnt:0};
  }
  
    handleDrawerOpen = (e) => {
    this.setState({ open: !this.state.open });
  };
   
    handleClick = (e) => {
    this.setState({ anchorEl: e.currentTarget,menuopen: !this.state.menuopen });
  };
  
   handleClose = (e) => {
    this.setState({ anchorEl: e.currentTarget,menuopen: !this.state.menuopen });
  };
    handlemenu1 = (e) => {
    this.setState({ menu1:  !this.state.menu1 });
  };
   handlemenumaster = (e) => {
    this.setState({ menu2:  !this.state.menu2 });
  };
   handlemenuaction = (e) => {
    this.setState({ menu3:  !this.state.menu3 });
  };
   
handleCallleadcnt = (childData) => {
        // Update the name in the component's state
		
        this.setState({ ldcnt: childData });
    };
 render() {
    return (
	
	
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" open={this.state.open}>
        <Toolbar className="adminheaderbg">
          <IconButton
            color="inherit" className="logobtn"
            aria-label="open drawer"
            onClick={this.handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(this.state.open && { display: 'none' }) }}
          >
            <MenuIcon /><img src={smalllogo} />
          </IconButton>
	<Slidenotification ref="Slidenotification" parentleadCallback={this.handleCallleadcnt}/>
          <div className="accountsec">
		  
	<ul className="linkslist">
	
	<li>
	<div className="accounticon">
	<img src={person} />
	</div>
	<div className="accountlogin">
	<p>Welcome</p>
	<h4>{ localStorage.getItem("AYLname")}</h4>
	</div><div className="clear"></div>
	</li>
	<li>
	 <Badge color="secondary"  badgeContent={this.state.ldcnt} color="error" >
          <NotificationsNoneIcon
onClick={()=>{this.refs.Slidenotification.handleFollowOpens()}}
		  />
        </Badge>
	</li>
	<li><Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
	 <div  className="submenus" onClick={this.handleClick} size="small" sx={{ ml: 2 }}><SettingsOutlinedIcon /></div></Box>
	 <Menu
        anchorEl={this.state.anchorEl}
        open={this.state.menuopen}
        onClose={this.handleClose}
        onClick={this.handleClose}
          PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 40,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        
     
		 <MenuItem>
         
		  <div className="setingdiv"><NavLink  to="/Staffchangepassword" className="colorlink">
		   
			
        Change Password
           </NavLink>
		  </div>
        </MenuItem>
       		
        <MenuItem>
         <div className="setingdiv">
		 <NavLink  to="/Logout" className="colorlink">
		   
			
            Logout
         </NavLink>
		  </div>
        </MenuItem>
		
		 	
          
		 
      </Menu></li>
	</ul>
	</div>
           
          
        </Toolbar>
      </AppBar>
	  
	
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
        variant="persistent"
        anchor={'left'} className="slidebg"
        open={this.state.open}
      >
        <DrawerHeader className="headerlogo">
		<img src={innerAthalogo} />
          <IconButton onClick={this.handleDrawerOpen}>
             <ChevronRightIcon />
          </IconButton>
        </DrawerHeader>
        {localStorage.getItem("AYLrole")==="2" && (
		 <List className="adminmenu"> 
		     <ListItem>
		 <NavLink  to="/Adminorder" > <SubdirectoryArrowRightIcon className="iconvertical"/> Manage Orders</NavLink>
       
       </ListItem>
	   
		     <ListItem>
		 <NavLink  to="/Adminbilling" > <SubdirectoryArrowRightIcon className="iconvertical"/> Manual Billing</NavLink>
       
       </ListItem>
	     <ListItem>
		 <NavLink  to="/Adminstrialclass" > <SubdirectoryArrowRightIcon className="iconvertical"/> Trial Class</NavLink>
       
       </ListItem>
	     <ListItem>
		<NavLink  to="/Adminleadmaster" > <SubdirectoryArrowRightIcon className="iconvertical"/>Leads Management</NavLink>
         
       </ListItem> 
	    <ListItem>
		<NavLink  to="/Subscription" > <SubdirectoryArrowRightIcon className="iconvertical"/> Subscription</NavLink>
         
       </ListItem>
	    <ListItem>
<NavLink  to="/Admincustomer" > <SubdirectoryArrowRightIcon className="iconvertical"/> Manage Customers</NavLink>
            </ListItem>
<ListItem>
		<NavLink  to="/Leadmasterreport" > <SubdirectoryArrowRightIcon className="iconvertical"/> Leads Report</NavLink>
         
       </ListItem> 	
 <ListItem>
	   <NavLink  to="/Leadsfollowpop" > <SubdirectoryArrowRightIcon className="iconvertical"/> Leads Followup Report</NavLink>
	   
	    </ListItem> 

<ListItem>
	   <NavLink  to="/LeadsFollowuplatestdate" > <SubdirectoryArrowRightIcon className="iconvertical"/> Missed Followup Report</NavLink>
         
       </ListItem> 		
<ListItem>
		<NavLink  to="/Renewalreport" > <SubdirectoryArrowRightIcon className="iconvertical"/> Renewal Report</NavLink>
         
       </ListItem>	
 <ListItem>
		<NavLink  to="/Trialclassreport" > <SubdirectoryArrowRightIcon className="iconvertical"/> Trial Class Report</NavLink>
         
       </ListItem>
 <ListItem>
		<NavLink  to="/Noshowreport" > <SubdirectoryArrowRightIcon className="iconvertical"/>No-Show Report</NavLink>
         
       </ListItem>	
<ListItem>
		 <NavLink  to="/ClientAttendreport" > <SubdirectoryArrowRightIcon className="iconvertical"/> Customer Attendance Report</NavLink> 
		 </ListItem>	

<ListItem>
		 <NavLink  to="/CustomerattendenceReport" > <SubdirectoryArrowRightIcon className="iconvertical"/> Manual Attendance Report</NavLink> 
</ListItem> 		 
	   </List>
		
		)}
       {localStorage.getItem("AYLrole")==="1" && (
        <List className="adminmenu"> 
		     <ListItem>
		 <NavLink  to="/Adminorder" > <SubdirectoryArrowRightIcon className="iconvertical"/> Manage Orders</NavLink>
       
       </ListItem>
	   
		     <ListItem>
		 <NavLink  to="/Adminbilling" > <SubdirectoryArrowRightIcon className="iconvertical"/> Manual Billing</NavLink>
       
       </ListItem>
	       
	    <ListItem>
		 <NavLink  to="/Adminstaffschedule" > <SubdirectoryArrowRightIcon className="iconvertical"/> Schedule Yoga Trainer</NavLink>
       
       </ListItem>
	    <ListItem>
		 <NavLink  to="/Admincustomerpostponerequest" > <SubdirectoryArrowRightIcon className="iconvertical"/> Postpone Request</NavLink>
       
       </ListItem>
	     <ListItem>
		 <NavLink  to="/Adminstrialclass" > <SubdirectoryArrowRightIcon className="iconvertical"/> Trial Class</NavLink>
       
       </ListItem>
		
	  
	
	   
	      	 
	   <ListItem onClick={this.handlemenuaction}>
	    <a className={this.state.menu3===true ? "menuactive" : ""}> <CardMembershipIcon className="iconvertical"/> Actions </a>
		
		{this.state.menu3===true && (
		<List className="adminsubmenu" > 
	   <ListItem>
		<NavLink  to="/Approveleave" > <SubdirectoryArrowRightIcon className="iconvertical"/> Approve Leaves</NavLink>
         
       </ListItem> 
	    <ListItem>
		<NavLink  to="/Adminleadmaster" > <SubdirectoryArrowRightIcon className="iconvertical"/>Leads Management</NavLink>
         
       </ListItem> 
		   
	      <ListItem>
		 <NavLink  to="/Adminfeedback" > <SubdirectoryArrowRightIcon className="iconvertical"/> Reviews</NavLink>
       
       </ListItem>
	   <ListItem>
		 <NavLink  to="/CustomerbyBranch" > <SubdirectoryArrowRightIcon className="iconvertical"/> Attendance</NavLink>
       
       </ListItem>
</List>

		)}
		
		   </ListItem>
	  
	   
	   <ListItem onClick={this.handlemenumaster}>
	    <a className={this.state.menu2===true ? "menuactive" : ""}> <TableViewIcon className="iconvertical"/> Masters </a>
		
		{this.state.menu2===true && (
		<List className="adminsubmenu" > 
		 <ListItem>
		<NavLink  to="/Branch" > <SubdirectoryArrowRightIcon className="iconvertical"/> Branches</NavLink>
         
       </ListItem>
		  <ListItem>
	   <NavLink  to="/Admincms" > <SubdirectoryArrowRightIcon className="iconvertical"/> Manage Content</NavLink>
        
       </ListItem>
	   <ListItem>
		<NavLink  to="/Addbanner" > <SubdirectoryArrowRightIcon className="iconvertical"/> Banners</NavLink>
         
       </ListItem>
	   <ListItem>

<NavLink  to="/Slotmanagement" > <SubdirectoryArrowRightIcon className="iconvertical"/> Manage Slots</NavLink>
   
       </ListItem>
	   <ListItem>
		<NavLink  to="/Subscription" > <SubdirectoryArrowRightIcon className="iconvertical"/> Subscription</NavLink>
         
       </ListItem>
	     <ListItem>
		 <NavLink  to="/Adminstaff" > <SubdirectoryArrowRightIcon className="iconvertical"/> Manage Yoga Trainer</NavLink>
       
       </ListItem>
	   <ListItem>
<NavLink  to="/Admincustomer" > <SubdirectoryArrowRightIcon className="iconvertical"/> Manage Customers</NavLink>
            </ListItem>	   
	   
	     <ListItem>
		  <NavLink  to="/Adminpromotion" > <SubdirectoryArrowRightIcon className="iconvertical"/> Coupon Code</NavLink>

       </ListItem>
	    <ListItem>
		 <NavLink  to="/Notificationcalendar" > <SubdirectoryArrowRightIcon className="iconvertical"/> Notifications</NavLink>
       
       </ListItem>
	    <ListItem>
		 <NavLink  to="/Holidaymanagement" > <SubdirectoryArrowRightIcon className="iconvertical"/> Holiday Management</NavLink>
       
       </ListItem>
	     <ListItem>
		 <NavLink  to="/Groupweeklyclasses" > <SubdirectoryArrowRightIcon className="iconvertical"/>  Group Weekly Classes</NavLink>
       
       </ListItem>
	  
		</List>
		
		)}
		
	    </ListItem>
	<ListItem onClick={this.handlemenu1}>
 <a className={this.state.menu1===true ? "menuactive" : ""}> <SummarizeIcon className="iconvertical"/> Reports </a>
{this.state.menu1===true && (
<List className="adminsubmenu" > 

<ListItem>
		<NavLink  to="/Leadmasterreport" > <SubdirectoryArrowRightIcon className="iconvertical"/> Leads Report</NavLink>
         
       </ListItem> 
	   <ListItem>
	   <NavLink  to="/Leadsfollowpop" > <SubdirectoryArrowRightIcon className="iconvertical"/> Leads Followup Report</NavLink>
         
       </ListItem> 
	   
	   <ListItem>
	   <NavLink  to="/LeadsFollowuplatestdate" > <SubdirectoryArrowRightIcon className="iconvertical"/> Missed Followup Report</NavLink>
         
       </ListItem> 
	   
	   	<ListItem>
		<NavLink  to="/Adminfeedbackreport" > <SubdirectoryArrowRightIcon className="iconvertical"/> Review Report</NavLink>
         
       </ListItem> 
	    	<ListItem>
		<NavLink  to="/Adminorderreports" > <SubdirectoryArrowRightIcon className="iconvertical"/> Order Report</NavLink>
         
       </ListItem> 
	     <ListItem>
		<NavLink  to="/Renewalreport" > <SubdirectoryArrowRightIcon className="iconvertical"/> Renewal Report</NavLink>
         
       </ListItem>
	   
	   <ListItem>
		<NavLink  to="/Freezingreport" > <SubdirectoryArrowRightIcon className="iconvertical"/> 
Group Freezing Report</NavLink>
         
       </ListItem>
	   <ListItem>
		<NavLink  to="/Trialclassreport" > <SubdirectoryArrowRightIcon className="iconvertical"/> Trial Class Report</NavLink>
         
       </ListItem>
	   
	   <ListItem>
		<NavLink  to="/Leavesreport" > <SubdirectoryArrowRightIcon className="iconvertical"/> Leaves Report</NavLink>
         
       </ListItem> 
<ListItem>
		<NavLink  to="/Notificationreport" > <SubdirectoryArrowRightIcon className="iconvertical"/> Notification Report</NavLink>
         
       </ListItem> 
	   <ListItem>
		<NavLink  to="/Customerreport" > <SubdirectoryArrowRightIcon className="iconvertical"/> Customer Report</NavLink>        
       </ListItem>
	   	     <ListItem>
		 
 <ListItem>
		<NavLink  to="/StaffScheduleReport" > <SubdirectoryArrowRightIcon className="iconvertical"/> Yoga Trainer Schedule Report</NavLink>
         
       </ListItem>
	      
	   <ListItem>
		<NavLink  to="/Staffchecheckinreport" > <SubdirectoryArrowRightIcon className="iconvertical"/>Yoga Trainer Attendance Report</NavLink></ListItem>
		
		<NavLink  to="/ClientAttendreport" > <SubdirectoryArrowRightIcon className="iconvertical"/> Customer Attendance Report</NavLink> 
		 </ListItem>
		
		<ListItem>
		<NavLink  to="/CustomerattendenceReport" > <SubdirectoryArrowRightIcon className="iconvertical"/> Manual Attendance Report</NavLink>
         
       </ListItem>

	    <ListItem>
		<NavLink  to="/Noshowreport" > <SubdirectoryArrowRightIcon className="iconvertical"/>No-Show Report</NavLink>
         
       </ListItem>
	     <ListItem>
		<NavLink  to="/Accountsreport" > <SubdirectoryArrowRightIcon className="iconvertical"/>Accounts Report</NavLink>
         
       </ListItem>
	    <ListItem>
		<NavLink  to="/Salesreport" > <SubdirectoryArrowRightIcon className="iconvertical"/>Sales Report</NavLink>
         
       </ListItem>
	   
	  
</List>
)}

	    </ListItem> 
	   	
	   
	   </List>
	   )}
   
 {localStorage.getItem("AYLrole")==="4" && (
		 <List className="adminmenu"> 
		     <ListItem>
		 <NavLink  to="/CustomerbyBranch" > <SubdirectoryArrowRightIcon className="iconvertical"/> Customer Attendance</NavLink>
       
       </ListItem>
	   
		     <ListItem>
		 <NavLink  to="/CustomerattendenceReport" > <SubdirectoryArrowRightIcon className="iconvertical"/> Manual Attendance Report</NavLink> 
</ListItem> 
	   	
	   
	   </List>
	   )}		 

	 </Drawer> 
      <Main open={this.state.open} className="drawerpad">
        <DrawerHeader />
		<div className="contentmain">
       <Outlet />
	   </div>
	   <div className="footerbg">
	   <p>© Copyright {(new Date().getFullYear())} AthaYog Living, All Rights Reserved</p>
	   </div>
	   
      </Main>
	 
	  
    </Box>
    );
  }
}






